import type { Location } from 'react-router-dom';

export const WALLET_ACTION_PARAM = 'walletAction';

export const hasWalletExportQuery = (search: string): boolean =>
  new URLSearchParams(search).get(WALLET_ACTION_PARAM) === 'export';

export const requestsWalletExport = (location: Location): boolean =>
  hasWalletExportQuery(location.search) || location.state?.openWalletExport === true;
